// Generated from SVG to Code Figma Plugin

export const Loading = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect height="5" width="2" fill="currentColor" rx="1" x="11" y="2" />
    <rect height="5" width="2" fill="currentColor" fillOpacity="0.52" rx="1" x="11" y="17" />
    <path
      d="M21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13H18C17.4477 13 17 12.5523 17 12C17 11.4477 17.4477 11 18 11H21Z"
      fill="currentColor"
      fillOpacity="0.76"
    />
    <path
      d="M6 11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H6Z"
      fill="currentColor"
      fillOpacity="0.28"
    />
    <path
      d="M4.92891 6.34309C4.53838 5.95257 4.53838 5.3194 4.92891 4.92888C5.31943 4.53836 5.9526 4.53836 6.34312 4.92888L8.46444 7.0502C8.85497 7.44072 8.85497 8.07389 8.46444 8.46441C8.07392 8.85494 7.44075 8.85494 7.05023 8.46441L4.92891 6.34309Z"
      fill="currentColor"
      fillOpacity="0.16"
    />
    <path
      d="M15.7071 17.1214C15.3166 16.7309 15.3166 16.0977 15.7071 15.7072C16.0976 15.3167 16.7308 15.3167 17.1213 15.7072L19.2426 17.8285C19.6332 18.219 19.6332 18.8522 19.2426 19.2427C18.8521 19.6333 18.219 19.6333 17.8284 19.2427L15.7071 17.1214Z"
      fill="currentColor"
      fillOpacity="0.64"
    />
    <path
      d="M17.6568 4.92903C18.0474 4.53851 18.6805 4.53851 19.0711 4.92903C19.4616 5.31955 19.4616 5.95272 19.0711 6.34324L16.9497 8.46456C16.5592 8.85509 15.926 8.85509 15.5355 8.46456C15.145 8.07404 15.145 7.44088 15.5355 7.05035L17.6568 4.92903Z"
      fill="currentColor"
      fillOpacity="0.88"
    />
    <path
      d="M7.05028 15.5355C7.4408 15.145 8.07397 15.145 8.46449 15.5355C8.85502 15.926 8.85502 16.5592 8.46449 16.9497L6.34317 19.071C5.95265 19.4615 5.31948 19.4615 4.92896 19.071C4.53843 18.6805 4.53843 18.0473 4.92896 17.6568L7.05028 15.5355Z"
      fill="currentColor"
      fillOpacity="0.4"
    />
  </svg>
);
